import React from 'react';

import { IconTypes } from '@eika/icon';
import { LinkCard } from '@eika/link-panel';

import { Header } from '../../components/header/header';
import { urler } from '../../router/router-urler';
import { getExternalUrlForSkadekategori } from '../deep-link-handler';
import { Skadekategori } from '../deep-link-handler/skadekategori';
import Container from './container';
import { generateDataTrackIdForLinkOnPartner, to } from './partner';

const { BIL_24, TRAKTOR_24, HONE_24, BONDEGARD_36, KONTOER_24 } = IconTypes;

const skadeMeldingsTyper: {
    title: string;
    textOne?: string;
    url: string;
    icon: IconTypes;
    'data-track-id': string;
}[] = [
    {
        url: getExternalUrlForSkadekategori(Skadekategori.Kjoretoy),
        title: 'Kjøretøy',
        icon: BIL_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Kjoretoy.valueOf()),
    },
    {
        url: getExternalUrlForSkadekategori(Skadekategori.Kjoretoy),
        title: 'Traktor og arbeidsmaskin',
        icon: TRAKTOR_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Kjoretoy.valueOf()),
    },
    {
        url: getExternalUrlForSkadekategori(Skadekategori.LandbrukProduksjonsdyr),
        title: 'Produksjonsdyr',
        icon: HONE_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.LandbrukProduksjonsdyr.valueOf()),
    },
    {
        url: getExternalUrlForSkadekategori(Skadekategori.Landbruk),
        title: 'Driftsbygninger, eiendeler og avling',
        icon: BONDEGARD_36,
        'data-track-id': generateDataTrackIdForLinkOnPartner(Skadekategori.Landbruk.valueOf()),
    },
    {
        url: to(urler().ettersendingUrl),
        title: 'Har du allerede meldt inn en skade?',
        textOne: 'Oppdater saken din her',
        icon: KONTOER_24,
        'data-track-id': generateDataTrackIdForLinkOnPartner('ettersending'),
    },
];
const header = <Header title="Landbruk" />;

export const LandbrukPartner = () => (
    <Container header={header}>
        <h3>Hva vil du melde skade på?</h3>
        {skadeMeldingsTyper
            .map((props) => ({
                ...props,
                key: props.title.replace(/\s/g, '_'),
                onClick: () => window.scroll(0, 0),
            }))
            .map((props) => (
                <LinkCard key={props.key} {...props} />
            ))}
    </Container>
);
